import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getPaperUtilityClass(slot: string) {
  return generateUtilityClass('O2Paper', slot);
}

const paperClasses = generateUtilityClasses('O2Paper', ['root', 'selected', 'content', 'footer']);

export default paperClasses;
